export default __webpack_public_path__ + "static/media/rss.fe36f023.svg";